export enum FilterItemKeys {
  NAME = "name",
  ID = "id",
  INHERIT_ENTITIES = "inheritEntities",
  CHILDREN = "children",
}
